enum LOOK_UP_TYPES {
  FETCH_LOOK_UP_VALUES = 'FETCH_LOOK_UP_VALUES',
  FETCH_MANDATORY_CLASSIFICATIONS = 'FETCH_MANDATORY_CLASSIFICATIONS',
  FETCH_OTHER_MANDATORY_CLASSIFICATIONS = 'FETCH_OTHER_MANDATORY_CLASSIFICATIONS',
  SET_LOOK_UP_VALUES = 'SET_LOOK_UP_VALUES',
  CLEAR_LOOKUP = 'CLEAR_LOOKUP',
  SET_PAYER_LOOK_UP_VALUES = 'SET_PAYER_LOOK_UP_VALUES',
  FETCH_PACKAGE = 'FETCH_PACKAGE',
  CLEAR_PAYER_LOOKUP = 'CLEAR_PAYER_LOOKUP',
  FETCH_INPATIENT_STATUSES = 'FETCH_INPATIENT_STATUSES',
  SET_PAYER_CLAIM_STATUSES = 'SET_PAYER_CLAIM_STATUSES',
  FETCH_ALL_INSURERS = 'FETCH_ALL_INSURERS',
  SET_ALL_INSURERS = 'SET_ALL_INSURERS',
  SET_ALL_GRIEVANCE = 'SET_ALL_GRIEVANCE',
  SET_ALL_GRIEVANCE_LOOKUP = 'SET_ALL_GRIEVANCE_LOOKUP',
  FETCH_ALL_ONMAIL_PAYERS = 'FETCH_ALL_ONMAIL_PAYERS',
  SET_ALL_ONMAIL_PAYERS = 'SET_ALL_ONMAIL_PAYERS',
  FETCH_PROVIDER_ROOM_TYPES = 'FETCH_PROVIDER_ROOM_TYPES',
  FETCH_GRIEVANCE_TYPES = 'FETCH_GRIEVANCE_TYPES',
  FETCH_ROLE_MASTER = 'FETCH_ROLE_MASTER',
  UPDATE_ROLE_MASTER = 'UPDATE_ROLE_MASTER',
  FETCH_LOOKUP_MASTER = 'FETCH_LOOKUP_MASTER',
  OTHER_TREATMENT_SELECTED = 'OTHER_TREATMENT_SELECTED',
  SET_DYNAMIC_DIAGNOSIS_VALUES = 'SET_DYNAMIC_DIAGNOSIS_VALUES',
  SET_DYNAMIC_LOOKUP_VALUES = 'SET_DYNAMIC_LOOKUP_VALUES',
  SET_DOCTOR_VALUES = 'SET_DOCTOR_VALUES',
  SYNONYM_TREATMENT_VALUE = 'SYNONYM_TREATMENT_VALUE',
  SYNONYM_TREATMENT_DATA_VALUE = 'SYNONYM_TREATMENT_DATA_VALUE',
  SYNONYM_DIAGNOSIS_DATA_VALUE = 'SYNONYM_DIAGNOSIS_DATA_VALUE',
  SET_REIMBURSEMENT_PAYER_CLAIM_STATUSES = 'SET_REIMBURSEMENT_PAYER_CLAIM_STATUSES',
  SET_DIAGNOSIS_VALUES = 'SET_DIAGNOSIS_VALUES',
  FETCH_BILL_DETAIL_VALUES = 'FETCH_BILL_DETAIL_VALUES',
  SET_BILL_DETAIL = 'SET_BILL_DETAIL',
  FETCH_DIAGNOSIS_LOOKUP_REQUEST = 'FETCH_DIAGNOSIS_LOOKUP_REQUEST',
  SET_ALL_PAYER_CLAIM_STATUSES = 'SET_ALL_PAYER_CLAIM_STATUSES',
  FETCH_LOOKUP_BYVALUE_REQUEST = 'FETCH_LOOKUP_BYVALUE_REQUEST',
  FETCH_GRIEVANCE_LOOK_UP = 'FETCH_GRIEVANCE_LOOK_UP',
  SET_GRIEVANCE_STATUSES = 'SET_GRIEVANCE_STATUSES',
  GET_HIS_TREATMENT_LOOKUP_VALUES = 'GET_HIS_TREATMENT_LOOKUP_VALUES',
}

export default LOOK_UP_TYPES;
